<template>
  <DateRangePicker
    :value="value"
    @change="handleChange($event)"
    :calendar="'CustomCalendar'"
    :popupSettings="isMobile() ? mobilePopupSettings : undefined"
    :max="$props.max"
    :min="$props.min"
  >
    <template v-slot:CustomCalendar="{ props }">
      <div
        v-bind="props"
        :id="props.id"
        tabindex="0"
        class="date-range-calendar"
        :class="{'mobile': isMobile()}"
        @focusin="props.onFocus"
        @focusout="props.onBlur"
        @keydown="props.onKeydown"
      >
        <Calendar
          :view-list-id="props.id"
          :views="1"
          :value="value.start!"
          :max="$props.max"
          :min="$props.min"
          @change="handleStartChange"
        />
        <Calendar
          :views="1"
          :value="value.end!"
          :max="$props.max"
          :min="$props.min"
          @change="handleEndChange"
        />
      </div>
    </template>
  </DateRangePicker>
</template>

<script setup lang="ts">
import {
  Calendar,
  type DateRangePickerPopupSettings,
  type DateRangePickerChangeEvent,
  type SelectionRange,
} from "@progress/kendo-vue-dateinputs";
import { DateRangePicker } from "@progress/kendo-vue-dateinputs";
import { isMobile } from "@/shared/helpers/mobileHelper";

const props = defineProps<{
  value: SelectionRange;
  max?: Date;
  min?: Date;
}>();

const emit = defineEmits<{
  (e: "change", value: SelectionRange): void;
}>();

const mobilePopupSettings = {
  animate: false,
  anchorAlign: {
    horizontal: "center",
    vertical: "bottom",
  },
  popupAlign: {
    horizontal: "center",
    vertical: "top",
  },
} as DateRangePickerPopupSettings;

const handleStartChange = function (event: { target: { value: Date } }) {
  let end = props.value.end;
  if (end && end < event.target.value) {
    end = event.target.value;
  }
  emit("change", {
    start: event.target.value,
    end: end,
  });
};

const handleEndChange = function (event: { target: { value: Date } }) {
  let start = props.value.start;
  if (start && start > event.target.value) {
    start = event.target.value;
  }
  emit("change", {
    start: start,
    end: event.target.value,
  });
};

const handleChange = function (args: any[]) {
  const event = args as any as DateRangePickerChangeEvent;
  emit("change", event.value);
};
</script>

<style scoped lang="scss">
.date-range-calendar {
  display: flex;

  &.mobile {
    flex-direction: column;
  }
}
</style>
